import type { ScenePreset } from './show';
import type { StudioState } from './studio-state';

export const LIVE_STATUSES = ['draft', 'scheduled', 'live', 'ended'] as const;

export type LiveStatus = (typeof LIVE_STATUSES)[number];

/** A single broadcast session, created from a Show. */
export interface Live {
  id: string;
  showId: string;
  title: string;
  description: string | null;
  /** ISO 8601 timestamp, or null when unscheduled. */
  scheduledAt: string | null;
  status: LiveStatus;
  /** null means "inherit the Show's scenePreset". */
  sceneOverride: ScenePreset | null;
  /**
   * What the studio was doing: on air, in preview, and the sources feeding it.
   * null on a Live that has never been opened.
   */
  studioState: StudioState | null;
  youtubeBroadcastId: string | null;
  livekitRoomName: string;
  recordingPath: string | null;
  createdBy: string | null;
  /** ISO 8601 timestamp. */
  createdAt: string;
  /** ISO 8601 timestamp. */
  updatedAt: string;
}

export interface CreateLiveInput {
  title: string;
  description?: string | null;
  scheduledAt?: string | null;
  status?: LiveStatus;
  sceneOverride?: ScenePreset | null;
  studioState?: StudioState | null;
}

export type UpdateLiveInput = Partial<CreateLiveInput>;
